import { Skeleton } from '../../../Skeleton'

import * as styles from './BirdviewHeaderSkeleton.module.css'

function BirdviewHeaderSkeleton({
  actionsContainerRef,
  hasResetLayout,
  hasScopeControl,
  hasViewControl,
}) {
  return (
    <header className={styles.header}>
      <div className={styles.intro}>
        <Skeleton className={styles.greeting} />
        <Skeleton className={styles.date} />
      </div>
      <div className={styles.controls}>
        {hasViewControl ? <Skeleton className={styles.control} /> : null}
        {hasScopeControl ? <Skeleton className={styles.control} /> : null}
        <div className={styles.actions} ref={actionsContainerRef} />
        {hasResetLayout ? <Skeleton className={styles.control} /> : null}
        <Skeleton className={styles.icon} />
      </div>
    </header>
  )
}

export default BirdviewHeaderSkeleton
